import React, { useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import DateIcon from "../../../imgs/date-icon.svg";
import PdfIcon from "../../../imgs/pdf-icon.svg";
import { esgReportCreate } from "../../../network/fetch";
import ProgressBar from "../../../components/ProgressBar/ProgressBar";
import TutorialPopup from "../../../components/TutorialPopup/TutorialPopup";

import State from "../State";

const Step1Form = () => {
  const total_steps = 2; // Par exemple, s'il y a 5 étapes au total
  const current_step = 1; // Étape actuelle
  const navigate = useNavigate();

  const [txUri, setTxUri] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const dateInputRef = useRef(null);

  // State pour les champs du formulaire
  const [formData, setFormData] = useState({
    field1: "",
    field2: "",
    field3: "",
    field4: [],
    date: new Date().toISOString().split("T")[0],
  });

  // State pour gérer l'état de soumission
  const [submitting, setSubmitting] = useState(false);

  // Gestion du changement d'entrée
  const handleChange = (e) => {
    isFormValid();
    const { name, value, type, files } = e.target;

    if (type === "file") {
      setFormData({
        ...formData,
        [name]: Array.from(files),
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }
  };

  // Gestion de la soumission du formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (isFormValid()) {
      setSubmitting(true);

      const formDataToSend = new FormData();

      const reportId =
        Math.floor(Math.random() * 1000000) +
        "-" +
        Math.floor(Math.random() * 1000000) +
        "-" +
        Math.floor(Math.random() * 1000000);

      console.log("=== formData.field4 === Step1Form.js === key: 075249 ===");
      console.dir(formData.field4, { depth: null, colors: true });
      console.log("=================================");

      formDataToSend.append("reportId", reportId); // Remplacez par une méthode pour générer un ID unique
      formDataToSend.append(
        "reportName",
        formData.field4[0].length
          ? formData.field4[0]["name"] || reportId
          : reportId
      );
      formData.field4[0] && formDataToSend.append("docType", formData.field4[0].type || "application/pdf"); // Supposons que le document soit un PDF
      formDataToSend.append("timestamp", new Date().toISOString());
      formDataToSend.append("author", "author"); // Remplacez par le nom réel de l'auteur
      formDataToSend.append("environment", formData.field1);
      formDataToSend.append("csr", formData.field2);
      formDataToSend.append("governance", formData.field3);
      formData.field4[0] && formDataToSend.append("file", formData.field4[0]);

      try {
        const response = await esgReportCreate(formDataToSend);

        console.log("=== response === Step1Form.js === key: 747535 ===");
        console.dir(response, { depth: null, colors: true });
        console.log("=================================");

        State.reportId = reportId;

        setTxUri(response.data.tx_uri);

        setIsLoading(false);

        setTutorialSteps(submitedStep);
        setTutorialStep(0);

        return;

        /** ---------------------- cmt ----------------------
         * if (response.success) {
            navigate("/esg-reporting/step2", {
              replace: true,
            });
          }
         *--------------------------------------------------*/
      } catch (error) {
        console.log("=== error === Step1Form.js === key: 866457 ===");
        console.dir(error, { depth: null, colors: true });
        console.log("=================================");
        console.error("Erreur lors de la soumission du formulaire:", error);
        //  alert('Erreur lors de la soumission du formulaire. Veuillez réessayer.');
      } finally {
        setSubmitting(false);
      }
    } else {
      //  alert('Veuillez remplir tous les champs requis.');
    }
    setIsLoading(false);
  };

  const isFormValid = () => {
    formData.field1 = formData.field1.replace(/\s+/g, " ");
    formData.field2 = formData.field2.replace(/\s+/g, " ");
    formData.field3 = formData.field3.replace(/\s+/g, " ");
    return (
      formData.field1 &&
      formData.field2 &&
      formData.field3 &&
      formData.field4.length > 0 &&
      formData.date
    );
  };

  const handleFileSelect = () => {
    document.getElementById("file-input").click();
  };

  const solutionNextStep = (e) => {
    e.preventDefault();
    navigate("/esg-reporting/step2", {
      replace: true,
    });
    return;
  };

  const handleNextTutorialStep = (e) => {
    e.preventDefault();
    if (tutorialStep < tutorialSteps.length - 1) {
      setTutorialStep(tutorialStep + 1);
    } else {
      setTutorialStep(-1); // Toutes les étapes sont terminées
    }
  };

  const handleCloseTutorial = (e) => {
    e.preventDefault();
    setTutorialStep(-1);
  };

  const [tutorialStep, setTutorialStep] = useState(0);
  const [tutorialSteps, setTutorialSteps] = useState([
    {
      content: (
        <>
          <p className="tutorial-title">Encodez vos données</p>
          <p>
            En tant qu’entreprise de transport impliquée dans la chaîne
            d’approvisionnement d’un produit, vous devez rapporter vos propres
            données ESG afin de compléter le cycle de traçabilité. Enregistrez
            vos données pour les rendre disponibles sur la blockchain.
          </p>
        </>
      ),
      closeLabel: "hidden",
      position: { top: "120px", left: "50%", transform: "translateX(-50%)" },
    },
    // Ajoutez plus d'étapes si nécessaire
  ]);
  let submitedStep = [
    {
      content: (
        <>
          <p className="tutorial-title">
            Vos informations ont été enregistrées avec succès
          </p>
          <p>
            Vous avez enregistré vos données ESG. Ces données sont désormais
            accessibles via la blockchain. Cliquez sur le bouton ci-dessous pour
            consulter les informations brutes disponibles sur la blockchain.
          </p>
        </>
      ),
      closeLabel: "hidden",
      nextLabel: "Etape suivante",
      handleNextTutorialStep: (e) => {
        solutionNextStep(e);
      },
      position: {
        top: "320px",
        left: "50%",
        transform: "translateX(-50%)",
        width: "950px",
      },
    },
  ];

  return (
    <form onSubmit={handleSubmit} className="container form-esg-1">
      <div className="form-heading-wrapper">
        <ProgressBar total_steps={total_steps} current_step={current_step} />
      </div>

      {/* Affichage du popup tutoriel */}
      {tutorialStep >= 0 && (
        <TutorialPopup
          content={tutorialSteps[tutorialStep].content}
          position={tutorialSteps[tutorialStep].position}
          isVisible={tutorialStep >= 0}
          onNext={
            tutorialSteps[tutorialStep].handleNextTutorialStep ||
            handleNextTutorialStep
          }
          onClose={handleCloseTutorial}
          txUrl={txUri}
          showArrow={tutorialSteps[tutorialStep].showArrow === true}
          tmpNextLabel={tutorialSteps[tutorialStep].nextLabel}
          tmpCloseLabel={tutorialSteps[tutorialStep].closeLabel}
        />
      )}

      <div className="fiels-main-wrapper">
        <div className="fields-main">
          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="date" className="form-label">
                Date de transport
              </label>
              <input
                type="date"
                className="form-control"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
                ref={dateInputRef}
                placeholder="2023-10-05"
              />
              <span
                className="date-icon"
                onClick={() =>
                  dateInputRef.current &&
                  dateInputRef.current.showPicker &&
                  dateInputRef.current.showPicker()
                }
              >
                <img src={DateIcon} alt="Date Icon"></img>
              </span>
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="field1" className="form-label">
                Émission de CO2 (Kg)
              </label>
              <input
                type="text"
                className="form-control"
                id="field1"
                name="field1"
                value={formData.field1}
                onChange={handleChange}
                required
                placeholder="Ex: 500"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="field2" className="form-label">
                Volume de marchandises transportées (m³)
              </label>
              <input
                type="text"
                className="form-control"
                id="field2"
                name="field2"
                value={formData.field2}
                onChange={handleChange}
                required
                placeholder="Ex: 100"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field">
              <label htmlFor="field3" className="form-label">
                Ressource humaine nécessaire (jour-homme)
              </label>
              <input
                type="text"
                className="form-control"
                id="field3"
                name="field3"
                value={formData.field3}
                onChange={handleChange}
                required
                placeholder="Ex: 2"
              />
            </div>
          </div>

          <div className="fields-main-item">
            <div className="form-field mb-0 file-wrapper">
              <label htmlFor="field4" className="form-label">
                Ajouter un document
              </label>
              <button
                type="button"
                className="btn btn-primary choose-file"
                onClick={handleFileSelect}
              >
                Ajouter
              </button>
              <input
                type="file"
                id="file-input"
                name="field4"
                multiple
                style={{ display: "none" }}
                onChange={handleChange}
              />
              <div className="file-preview">
                {formData.field4.map((file, index) => (
                  <div key={index} className="file-preview-item">
                    <span className="pdf-icon">
                      <img src={PdfIcon} alt="PDF Icon"></img>
                    </span>
                    <span>{file.name}</span>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="btn-wrapper">
          {!isLoading && !txUri && (
            <>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={!isFormValid()}
              >
                Soumettre
              </button>
            </>
          )}
          {isLoading && (
            <div className="spinner-wrapper">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </form>
  );
};

export default Step1Form;
